import { Component, Input } from '@angular/core';

import { BreadcrumbsService } from '../../../core/services/breadcrumbs/breadcrumbs.service';
import { Breadcrumb } from '../../models/common';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
  @Input() breadcrumbBackFilter: Record<string, any> = {};
  @Input() customTitle!: string;
  @Input() disable!: boolean;
  @Input() routeLink!: boolean;
  @Input() disabledRoutesList: string[] = [];
  @Input() redirectedFrom: string | null = null; // breadcrumb customTitle
  @Input() customIndex: number | null = null; // position of the text
  @Input() route: string | null = null; // roterLink

  breadcrumbs$: Observable<Breadcrumb[]>;

  constructor(private readonly breadcrumbsService: BreadcrumbsService) {
    this.breadcrumbs$ = this.breadcrumbsService.getBreadcrumb$();
  }
}
